  function initializePopup() {
  let popUp = document.querySelector(".pop-up");
  let overlay = document.querySelector(".overlay");
  let body = document.body;

  const getScrollbarWidth = () => {
    const outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.overflow = 'scroll';
    document.body.appendChild(outer);

    const inner = document.createElement('div');
    outer.appendChild(inner);

    const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;

    outer.parentNode.removeChild(outer);

    return scrollbarWidth;
  };

  const openPopUp = (e) => {
    const scrollbarWidth = getScrollbarWidth();
    popUp.classList.add("opened");
    overlay.classList.add("opened");
    body.style.overflow = "hidden"; // Disable scrolling
    body.style.paddingRight = `${scrollbarWidth}px`; // Add padding to compensate for scrollbar
  };

  const closePopUp = () => {
    popUp.classList.remove("opened");
    overlay.classList.remove("opened");
    body.style.overflow = ""; // Enable scrolling
    body.style.paddingRight = ""; // Remove added padding
  };

  document.querySelectorAll(".popup-trigger").forEach((button) => {
    button.addEventListener("click", (e) => {
      e.preventDefault();
      openPopUp();
    });
  });

  if(!overlay) {
    return;
  }

  overlay.addEventListener("click", closePopUp);
  document
    .getElementById("close-popup")
    .addEventListener("click", closePopUp);

  // Close the popup when the Escape key is pressed
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && popUp.classList.contains("opened")) {
      closePopUp();
    }
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initializePopup();
});
  